import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass,faComputer,faRobot } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "TypeScript",
    "JavaScript",
    "HTML5",
    "CSS3",
    "SASS",
    "Python",
    "SQL",
    "Postman",
    "Git",
    "GitHub Actions",
    "Docker",
    "Linux",
    "Selenium",
    "Jenkins"
];

const labelsSecond = [
"AGILE Testing",
"AI-assisted Testing",
"Test Design and Planning",
"Defect Reporting & Root Cause Analysis",
"QA Management",
"User Acceptance Testing (UAT)",
"Manual & Exploratory Testing",
"CI/CD Regression Testing",
"Cross-Browser Testing",
"API Testing"
];

const labelsThird = [
    "ChatGPT",
    "Claude",
    "Gemini",
    "LangChain",
    "CrewAI",
    "Github Copilot"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faComputer} size="3x"/>
                    <h3>Scripting and Programming</h3>
                    <p>I've developed experience with different languages over the years that I've been during my journey.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faMagnifyingGlass} size="3x"/>
                    <h3>Software Quality Engineering Skills</h3>
                    <p>I've created and aided in the creation of CI/CD pipelines utilizing the tools below. Regardless of the role. I make sure that the project is well tested and reado to go.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Test stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faRobot} size="3x"/>
                    <h3>GenAI & LLM</h3>
                    <p>I use as well as build my own AI Agents in order to help me accomplish tasks faster. I strictly believe in the "Human in the Loop" (HITL) style of AI use since computers can't understand humans as well as we understand each other.</p>
                    <div className="flex-chips">
                        <span className="chip-title">AI stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;
